/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import Switch from "../Switch";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class RoleEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/policy/list', 'policies');
        if (this.props.params.id)
            await this.load(this.props.params.id);
    }

    load = async (id) => {
        try {
            let j = await qreq.getAsync('/api/role/get/' + id);
            if (j.item) {
                j.item.accountLevel = String(j.item.accountLevel);
                this.setState({ info: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    submit = async (e) => {
        e.preventDefault();
        try {
            let info = { ...this.state.info };
            if (!info.accountLevel)
                info.accountLevel = 0;
            else
                info.accountLevel = parseInt(info.accountLevel);
            let j = await qreq.postAsync('/api/role/save', info);
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else {
                this.success('Saved!');
                this.goBack();
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    togglePolicy = (policy) => {
        let roles = this.state.info.roles || [];
        if (!roles)
            roles = [];
        var idx = roles.indexOf(policy.ident);
        if (idx === -1)
            roles.push(policy.ident);
        else
            roles.splice(idx, 1);
        this.setState({ info: { ...this.state.info, roles } });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Edit Role</L></h1>
                <form onSubmit={this.submit}>
                    <AppActions>
                        <button type="submit" className="btn btn-lg btn-primary"><Icon icon="faSave" /> <L>Save</L></button>
                    </AppActions>
                    <Card title="Role">
                        <FormInput model={this.state.info} name="name" label="Role Name" onChange={this.change} required />
                        <FormInput model={this.state.info} name="isLinkedToAccounts" label="Role is linked to accounts" type="switch" onChange={this.change} />
                        {this.state.info.isLinkedToAccounts && <FormInput
                            model={this.state.info}
                            name="accountLevel"
                            label="Account Level"
                            type="select"
                            options={[
                                { id: -1, name: 'Any Level' },
                                { id: 0, name: 'Level 0' },
                                { id: 1, name: 'Level 1' },
                                { id: 2, name: 'Level 2' },
                                { id: 3, name: 'Level 3' }]}
                            onChange={this.change}
                        />}
                        <div>
                            <label className="form-label"><L>Policies</L></label>
                            <ul className="list-group">
                                {this.state.policies?.filter(x => x.ident !== '!').map((i, idx) => (
                                    <li key={idx} className="list-group-item">
                                        <Switch label={i.name} checked={this.state.info.roles && this.state.info.roles.includes(i.ident)} onChange={() => this.togglePolicy(i)} />
                                        <div className="text-muted">{i.description}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Card>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(RoleEdit);